import * as actionType from "./types";
import axios from "../../../common/config/axios";
import { isDesktop } from "react-device-detect";

export const getVendorList = (props) => (dispatch, getState) => {
  props.country_id = getState().currentUser.data.country_id;
  props.language_code = getState().currentUser.data.language_code;
  props.country_code = getState().currentUser.data.country_code;
  axios
    .get(`${isDesktop ? "speed" : "home"}/vendor_list`, { params: props })
    .then(function (response) {
      dispatch({
        type: actionType.VENDOR_LIST,
        value: response.data,
      });
    });
};

export const getGameList = (props) => (dispatch) => {
  axios.get("speed/game_list", { params: props })
    .then(function (response) {
      dispatch({
        type: actionType.GAME_LIST,
        value: response.data,
      });
    });
};

export const accessGame = (props, vendor) => (dispatch) => {
  axios
    .post(`${vendor}/get_game_url`, props)
    .then((response) => {
      dispatch({
        type: actionType.SPEED_GAME_ACCESS,
        value: response.data,
      });
    });
};
